// Talkie-walkie du chauffeur: écoute automatique du répartiteur + bouton pour répondre.
import { useEffect, useState } from "react";
import PTTButton from "@/components/PTTButton";
import usePTTInbox from "@/hooks/usePTTInbox";
import { pttQueueSize } from "@/lib/pttQueue";
import { Radio, Volume2, X } from "lucide-react";

export default function DriverPTT({ floating = false }) {
  const [pending, setPending] = useState(0);
  const [open, setOpen] = useState(false);
  const { playing, blocked, unlock } = usePTTInbox({ pollMs: 5000 });

  useEffect(() => {
    const t = setInterval(() => pttQueueSize().then(setPending), 5000);
    pttQueueSize().then(setPending);
    return () => clearInterval(t);
  }, []);

  const status = playing
    ? <span className="text-xs font-bold text-emerald-400 flex items-center gap-1" data-testid="driver-ptt-playing">
        <Volume2 className="w-4 h-4 animate-pulse" /> {playing.from_name}
      </span>
    : pending > 0
      ? <span className="text-xs text-amber-400" data-testid="driver-ptt-pending">{pending} en attente d'envoi</span>
      : <span className="text-xs text-white/40">à l'écoute</span>;

  if (floating) {
    return (
      <>
        <button onPointerDown={() => { if (blocked) unlock(); setOpen(true); }}
          data-testid="driver-ptt-open"
          className={`fixed bottom-28 right-3 z-[500] w-16 h-16 rounded-full shadow-lg flex flex-col items-center justify-center
            ${playing ? "bg-emerald-500 text-slate-900 animate-pulse" : "bg-yellow-400 text-slate-900"}`}>
          <Radio className="w-7 h-7" />
          <span className="text-[9px] font-extrabold">PARLER</span>
        </button>
        {open && (
          <div className="fixed inset-0 z-[9998] bg-slate-950/95 flex flex-col justify-end p-4 driver-app" data-testid="driver-ptt-sheet">
            <div className="flex items-center justify-between mb-3">
              <span className="text-white font-display font-extrabold text-lg flex items-center gap-2">
                <Radio className="w-5 h-5" /> Répartition
              </span>
              <button onClick={() => setOpen(false)} data-testid="driver-ptt-close"
                className="w-12 h-12 rounded-full bg-white/10 text-white flex items-center justify-center">
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="mb-3">{status}</div>
            <PTTButton channel="dispatch" variant="driver" label="MAINTENIR POUR PARLER" />
          </div>
        )}
      </>
    );
  }

  return (
    <div onPointerDown={blocked ? unlock : undefined}
      className={`rounded-2xl bg-slate-900 border ${playing ? "border-emerald-400" : "border-white/10"} p-3`}
      data-testid="driver-ptt">
      <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] font-bold uppercase tracking-widest text-white/50 flex items-center gap-1.5">
          <Radio className="w-3.5 h-3.5" /> Répartition
        </span>
        {status}
      </div>
      {blocked && (
        <div className="text-[11px] text-amber-300 mb-2" data-testid="driver-ptt-unlock">
          Touchez l'écran une fois pour activer le son des messages.
        </div>
      )}
      <PTTButton channel="dispatch" variant="driver" label="MAINTENIR POUR PARLER" />
    </div>
  );
}
